import { useEffect } from 'react';
import { TRANSITION_DURATION } from '../constants';
export const useTransitionDurationVar = contentRef => {
  /**
   * @description
   * Синхронизируем transition-duration через css var
   */
  useEffect(() => {
    var _contentRef$current;
    (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.style.setProperty('--transition-duration', "".concat(TRANSITION_DURATION, "ms"));
  }, [contentRef]);
};